
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.45 10.45"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"fill":"#0072c8","d":"M10.17 5a.27.27 0 01.28.28.24.24 0 01-.08.19.28.28 0 01-.2.08H5.5v4.67a.3.3 0 01-.08.2.27.27 0 01-.19.08.27.27 0 01-.23-.33V5.5H.27A.27.27 0 010 5.23.28.28 0 01.08 5a.24.24 0 01.19 0H5V.27a.27.27 0 010-.19.3.3 0 01.23-.08.27.27 0 01.27.27V5z","data-name":"Layer 1"}})])])
          )
        }
      }
    